module.exports = __webpack_public_path__ + "img/magnifier-zoom-search.c41de0cc.gif";